import React from 'react';

const CommonBannar = ({ title, des }) => {
    return (
        <section className="faq-hero-section">
            <div className="faq-hero-content">
                <h1 className="faq-hero-title">{title}</h1>
                <p className="faq-hero-subtitle">{des}</p>

            </div>
        </section>
    );
};

export default CommonBannar;